import React from 'react';

import InventoryCard from './InventoryCard';
import InventoryTable, { InventoryTableRow } from './InventoryTable';
import { PairedFlightRow } from './useCharterInventory';

type DepartingFlightsCardProps = {
  rows: Array<PairedFlightRow>;
  label?: string;
  stayDurations?: Array<number>;
};

export default function DepartingFlightsCard({ rows, label, stayDurations }: DepartingFlightsCardProps) {
  const tableRows = rows.flatMap<InventoryTableRow>((row) =>
    row.departing.fareInventory.map((fare) => ({
      stayDuration: row.stayDuration,
      flight: row.departing,
      fare,
      uniqueKey: `${row.id}-${fare.bookingClass}`,
    })),
  );

  if (!rows.length) {
    return (
      <InventoryCard title="Departing flights" subheader={label ?? 'No departing flights'}>
        <InventoryTable
          rows={tableRows}
          emptyMessage="No departing flights to display."
          showStayDuration={!!stayDurations?.length}
        />
      </InventoryCard>
    );
  }

  const routeLabel = label ?? `${rows[0].departing.depAirport} → ${rows[0].departing.arrAirport}`;

  return (
    <InventoryCard title="Departing flights" subheader={routeLabel}>
      <InventoryTable
        rows={tableRows}
        emptyMessage="No departing flights to display."
        showStayDuration={!!stayDurations?.length}
      />
    </InventoryCard>
  );
}
